import React from 'react';
import classes from './AccountIcon.module.css';

interface IAccountIconProps {
    width?: number;
    height?: number;
    fill?: string;
}

const AccountIcon: React.FC<IAccountIconProps> = ({ width = 24, height = 24, fill = '#222222' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 48 48"
            fill="none"
            stroke="currentColor"
            strokeWidth={3}
            className={classes.icon}
        >
            <path d="M24 24c3.85 0 7-3.15 7-7s-3.15-7-7-7-7 3.15-7 7 3.15 7 7 7zm0 3c-6.05 0-18 3.05-18 9v3h36v-3c0-5.95-11.95-9-18-9z" />
        </svg>
    );
};

export default AccountIcon;
